import { render, staticRenderFns } from "./QuoteElement.vue?vue&type=template&id=36a002d3&"
import script from "./QuoteElement.vue?vue&type=script&lang=js&"
export * from "./QuoteElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports